import { useInToc } from "gatsby-source-dek-wp"
import React from "react"

export const H1 = (props) => {
  const [ref] = useInToc(props.children, true)
  return <h1 {...props} ref={ref} />
}